import { useNavigate, useSearch } from "@tanstack/react-router";
import { Header } from "@/app/layout/Header";
import { Main } from "@/app/layout/Main";
import type { OffsetPageQueryDTO } from "@/shared/contracts/base";
import { Breadcrumb } from "@/shared/ui/Breadcrumb";
import type { ReportListItem } from "../api/client";
import { useReportsQuery } from "../api/queries";
import { ReportsFilter } from "../ui/ReportsFilter";
import { ReportsTable } from "../ui/ReportsTable";
import { ReportsToolbar } from "../ui/ReportsToolbar";

export function ReportsPage() {
  const nav = useNavigate({ from: "/app/moderation/reports" });
  const search = useSearch({
    from: "/app/moderation/reports",
  }) as OffsetPageQueryDTO;

  const list = useReportsQuery({
    limit: search.limit ?? 20,
    offset: search.offset ?? 0,
    sort: search.sort,
    filters: search.filters,
  });

  const data = list.data?.data ?? [];
  const meta = list.data?.meta ?? { total: 0, limit: 20, offset: 0 };

  return (
    <>
      <Header>
        <Breadcrumb
          items={[
            { label: "ແຜງຄວບຄຸມ", to: "/app/dashboard" },
            { label: "ການກວດກາຕະຫຼາດ", to: "/app/moderation" },
            { label: "ລາຍງານ" },
          ]}
        />
      </Header>

      <Main>
        <ReportsToolbar />

        <div className="flex flex-col rounded-xl border bg-card pt-2">
          <ReportsFilter />

          <ReportsTable
            isLoading={list.isLoading}
            data={data}
            offset={meta.offset}
            limit={meta.limit}
            totalCount={meta.total}
            sortBy={search.sort?.[0]?.field}
            sortOrder={search.sort?.[0]?.dir}
            onView={(row: ReportListItem) =>
              nav({
                to: "/app/moderation/reports/$id",
                params: { id: row.id },
              })
            }
            onPaginationChange={(offset, limit) =>
              nav({ search: { ...search, offset, limit } })
            }
            onSortingChange={(id, desc) =>
              nav({
                search: {
                  ...search,
                  offset: 0,
                  sort: [{ field: id, dir: desc ? "desc" : "asc" }],
                },
              })
            }
          />
        </div>
      </Main>
    </>
  );
}
